import { useEffect, useState } from "react";
import { Layout, Progress, SectionHeading, Wizard } from "@vwfs-bronson/bronson-react";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { getRoundedPercentage } from "../../helpers/getRoundedPercentage";
import { Loading } from "../ui/Loading";
import { useTranslation } from "react-i18next";

export const MatchMakerWizard = () => {
    const { t } = useTranslation("matchmakerwizard");
    const { steps, currentStep } = useMatchMakerWizard();
    const [pathStepIndex, setPathStepIndex] = useState(0);
    const [maxPathStep, setMaxPathStep] = useState(0);

    useEffect(() => {
        setPathStepIndex(steps[currentStep.id - 1].paths.indexOf(currentStep.path) + 1);
        setMaxPathStep(steps[currentStep.id - 1].paths.length);
    }, [currentStep, steps]);

    return (
        <>
            <Loading />
            <Layout flush>
                <Layout.Item>
                    <Wizard 
                    ariaLabel={t("matchmakerwizard:wizard-aria-label")}
                    collapseBreakpoint="s"
                    stepLabels={{
                        doneLabel: 'completed',
                        errorLabel: 'invalid',
                        noInteractionLabel: 'no interaction',
                        notDoneLabel: 'upcoming'
                    }}
                    >
                        {steps.map(({ title, id }) => (
                            <Wizard.Item
                                key={id}
                                noInteraction
                                active={id === currentStep.id}
                                done={id < currentStep.id}
                                href={`#/match-maker/question-page${id}`}
                            >
                                {title}
                            </Wizard.Item>
                        ))}
                    </Wizard>
                </Layout.Item>
                <Layout.Item>
                    <SectionHeading level={1}>{currentStep.path.title}</SectionHeading>
                </Layout.Item>
                {maxPathStep > 1 && (
                    <Layout.Item>
                        <Layout middle>
                            <Layout.Item default="11/12" m="10/12" xs="9/12">
                                <Progress value={getRoundedPercentage(pathStepIndex, maxPathStep)} />
                            </Layout.Item>
                            <Layout.Item
                                default="1/12"
                                m="2/12"
                                xs="3/12"
                            >{`${pathStepIndex} / ${maxPathStep}`}</Layout.Item>
                        </Layout>
                    </Layout.Item>
                )}
            </Layout>
        </>
    );
};
